import Vue from 'vue'
import App from './App.vue'
import router from './router'

if (!window.Vue) { // esto es solo para pos-documents
  window.Vue = Vue;
}

// Import Bootstrap CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-icons/font/bootstrap-icons.css";
// Global stylesheet for every <multiselect> in the app (earnings-withholding,
// ecommerce users/catalogs); it used to be imported from Edit-modal.vue.
import 'vue-multiselect/dist/vue-multiselect.min.css';

import './assets/sass/app.scss';

import jquery from "jquery";
window.$ = window.jQuery = jquery;

import 'bootstrap/dist/js/bootstrap.bundle';

require('datatables.net-bs4');

require('datatables.net-select-bs4');

require('chart.js');

import axios from './services/index.js';
Vue.prototype.$http = axios; // Esto es para que ande el typeahead
window.axios = axios; // esto es solo para pos-documents

import store from './store';

import moment from 'moment'
Vue.prototype.moment = moment

import ConfirmPlugin from './components/global/confirm';
Vue.use(ConfirmPlugin);

import PermissionsPlugin from './components/global/permissions';
Vue.use(PermissionsPlugin, { store });

Vue.config.productionTip = false

store.dispatch('theme/init');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
